<template>
  <v-container >
    <v-row justify="center" v-if="!loading">
      <Address v-if="state === 'ADDRESS'" v-bind:location-change-callback="locationChange"/>
      <WasteType v-if="state === 'WASTE_TYPE'" v-bind:waste-types="wasteTypes" v-bind:proceed="wasteTypeChange"/>
      <ServiceType v-if="state === 'SERVICE_TYPE'" v-bind:vehicles="selectedWasteType.vehicles" v-bind:proceed="serviceTypeChange"/>
      <ConfirmInfo v-if="state === 'CONFIRM'"
                   v-bind:waste-type="selectedWasteType"
                   v-bind:vehicle="selectedVehicle"
                   v-bind:captured-address="capturedAddress"
                   v-bind:service-provider-id="serviceProviderId"
                   v-bind:location="location"
                   v-bind:postCode="postCode"
      />
    </v-row>

    <v-row justify="center" v-if="loading">
      <Loading/>
    </v-row>
  </v-container>

</template>

<script>
import Address from '@/components/fast-quote/Address';
import WasteType from '@/components/fast-quote/WasteType';
import ServiceType from '@/components/fast-quote/ServiceType';
import ConfirmInfo from '@/components/fast-quote/ConfirmInfo';
import Loading from '@/components/Loading';

const FAST_QUOTE_STATE = ['ADDRESS','WASTE_TYPE','SERVICE_TYPE','CONFIRM'];

export default {
  name: "FastQuote",
  components: { Loading, ConfirmInfo, ServiceType, WasteType, Address },
  data () {
    return {
      loading: false,
      user: Object,
      location: {},
      capturedAddress: '',
      postCode: '',
      step: 0,
      state: FAST_QUOTE_STATE[0],
      selectedVehicle: {},
      selectedWasteType: {},
      serviceProviderId: ''
    }
  },
  methods: {
    nextStep(){
      this.step++;
      this.state = FAST_QUOTE_STATE[this.step];
    },
    async locationChange(to, ad, code) {
      this.capturedAddress = ad;
      this.postCode = code;
      this.location = to;
      if (this.location.postal_code != null || this.postCode != ''){ 
        this.loading = true;
        await this.getWasteTypesForArea();
      }  
    },
    wasteTypeChange(wasteType) {
      this.selectedWasteType = wasteType;
      this.nextStep();
    },
    serviceTypeChange(serviceType) {
      this.selectedVehicle = serviceType;
      this.nextStep();
    },
    async getWasteTypesForArea() {
      const postalCode = this.location.postal_code ? Number.parseInt(this.location.postal_code) : Number.parseInt(this.postCode);
      await this.$store.dispatch('fetchWasteTypesByArea', postalCode);
    }
  },
  computed: {
    vehicles() {
      return this.$store.getters.getVehicles;
    },
    wasteTypes() {
      return this.$store.getters.getWasteTypes;
    },
    areas(){
      return this.$store.getters.getAreas;
    },
    waste() {
      return this.$store.getters.getWaste;
    },
  },
  watch: {
    wasteTypes() {
      this.nextStep();
      this.loading = false;
    },
    waste(waste){
      if(waste.length == 0 && !this.wasteTypes){
        alert("Sorry, we currently don’t service this area. Please contact us on 072 245 9777 so that we can 'Get it Sorted'");
        this.$router.go();
      }
    }
  },
  mounted(){
    this.$store.dispatch('fetchAreas');
  }
}
</script>
